import { IOfferCard } from '../../../types';

export const isFromLeadFactory = ({ newbuilding }: IOfferCard) => Boolean(newbuilding && newbuilding.isFromLeadFactory);
